import React, { ReactNode } from 'react';
import { createChildSlot } from '../createChildSlot';
import { TableActionCellProps } from '@wix/design-system';

export interface RowColumnSlotProps {
  children?: React.ReactNode;
  width?: string | number;
  align?: 'left' | 'center' | 'right';
  title?: ReactNode;
}
export const RowColumnSlot = createChildSlot<RowColumnSlotProps>();

export interface RowActionsColumnProps
  extends RowColumnSlotProps,
    Partial<TableActionCellProps> {}
export const RowActionsColumnSlot = createChildSlot<RowActionsColumnProps>();
